import { render, staticRenderFns } from "./PageBICompetition.vue?vue&type=template&id=1b61e550"
import script from "./PageBICompetition.vue?vue&type=script&lang=js"
export * from "./PageBICompetition.vue?vue&type=script&lang=js"
import style0 from "./PageBICompetition.vue?vue&type=style&index=0&id=1b61e550&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports